export default "__VITE_ASSET__CNbaZgLR__"